/* "Topes" (UX-11): the organizations in the mockup's table, and the ceiling form in its dialog. */
.scroll {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--border);
  text-align: left;
  white-space: nowrap;
}

.table td {
  block-size: 48px;
}

.table thead th {
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}

.table tbody th {
  font-weight: var(--font-weight-medium);
  color: var(--text);
}

.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-bottom: 0;
}

.table tbody tr:hover {
  background: var(--state-hover);
}

.muted {
  color: var(--text-muted);
}

.action {
  text-align: right !important;
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.note {
  margin: 0;
  font-size: var(--font-size-13);
  color: var(--text-muted);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.preview {
  margin: var(--space-1) 0 0;
  font-size: var(--font-size-12);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.refusal {
  margin: 0;
  font-size: var(--font-size-13);
  color: var(--danger-text);
}

.saved {
  margin: 0;
  font-size: var(--font-size-13);
  color: var(--success-text);
}
